import * as Actions from './permutarNeumaticosActions'
import { CocheType } from '../cocheType'

export const version = 1
export const key = 'permutarNeumaticos'

export const initialState = {
  loading: false as boolean,
  error: null as string | null,
  vehicle: null as CocheType | null,
  matricula: null as string | null,
  step: 1 as number,
}

export type PermutarNeumaticosState = typeof initialState

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.PERMUTAR_NEUMATICOS_SET:
      return {
        ...state,
        matricula: action.payload.matricula,
        vehicle: action.payload.vehicle,
      }
    case Actions.PERMUTAR_NEUMATICOS_RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
